module.exports = __webpack_public_path__ + "img/arrow.ba2062d2.svg";